// extracted by mini-css-extract-plugin
module.exports = {"leadership-cards-list":"LeadershipList_leadership-cards-list__1mH66","leadership-owners-list":"LeadershipList_leadership-owners-list__1EnnF"};